// The session token lives in localStorage so a login survives reloads. Storage can be
// unavailable (private mode, blocked site data), so every access is guarded.
const KEY = "ct.session";
const listeners = new Set<() => void>();
let memoryToken: string | null = null;

export function getToken(): string | null {
  try {
    return localStorage.getItem(KEY) ?? memoryToken;
  } catch {
    return memoryToken;
  }
}

export function setToken(token: string | null): void {
  memoryToken = token;
  try {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  } catch {
    // Keep the in-memory copy only.
  }
  listeners.forEach((l) => l());
}

export function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
